import { useIsMobile } from '@ori/presentation-hooks';
import { Skeleton } from '@ori-ui/mui';
import React, { useMemo } from 'react';
import { ICON_BUTTON_PHONE_SIZE, ICON_BUTTON_SIZE, ICON_BUTTON_SKELETON } from "../../common";
import { jsx as _jsx } from "react/jsx-runtime";
export var IconButtonSkeleton = function IconButtonSkeleton() {
  var isMobile = useIsMobile();
  var size = useMemo(function () {
    return isMobile ? ICON_BUTTON_PHONE_SIZE : ICON_BUTTON_SIZE;
  }, [isMobile]);
  return /*#__PURE__*/_jsx(Skeleton, {
    variant: "circular",
    width: size,
    height: size,
    "data-testid": ICON_BUTTON_SKELETON
  });
};
//# sourceMappingURL=IconButtonSkeleton.js.map